import { useRef } from "react";
import { motion, useInView } from "framer-motion";

const MONO = { fontFamily: "'JetBrains Mono', monospace" };

const CORTISOL =
  "M 20 190 C 50 185, 70 180, 90 170 C 120 150, 140 110, 160 90 C 172 70, 185 52, 195 50 C 215 55, 235 80, 253 95 C 280 108, 300 118, 323 125 C 350 134, 370 144, 393 150 C 420 158, 440 166, 463 170 C 490 177, 515 183, 533 185 C 550 187, 568 189, 580 190";

const MELATONIN =
  "M 20 60 C 45 50, 70 44, 90 45 C 110 50, 125 60, 137 70 C 155 95, 170 135, 183 160 C 198 180, 215 192, 230 195 C 255 198, 278 200, 300 200 C 345 199, 395 199, 440 198 C 458 196, 473 192, 487 185 C 500 177, 512 165, 522 150 C 535 128, 548 105, 557 90 C 566 78, 574 70, 580 65";

const HOURS = [
  [20, "00"],
  [160, "06"],
  [300, "12"],
  [440, "18"],
  [580, "24"],
];

export const HormoneCurves = () => {
  const ref = useRef(null);
  const inView = useInView(ref, { once: true, margin: "-40px" });

  return (
    <div ref={ref} data-testid="science-hormone-curves">
      <svg viewBox="0 0 600 250" className="w-full">
        {HOURS.map(([x, l]) => (
          <line key={l} x1={x} y1="24" x2={x} y2="210" stroke="#1A1C20" strokeWidth="1" />
        ))}
        <line x1="20" y1="210" x2="580" y2="210" stroke="#2A2C30" strokeWidth="1" />

        <motion.path
          d={MELATONIN}
          fill="none"
          stroke="#6E7178"
          strokeWidth="2.5"
          strokeLinecap="round"
          initial={{ pathLength: 0 }}
          animate={inView ? { pathLength: 1 } : { pathLength: 0 }}
          transition={{ duration: 1.8, ease: [0.22, 1, 0.36, 1] }}
        />
        <motion.path
          d={CORTISOL}
          fill="none"
          stroke="#FF4D0A"
          strokeWidth="2.5"
          strokeLinecap="round"
          initial={{ pathLength: 0 }}
          animate={inView ? { pathLength: 1 } : { pathLength: 0 }}
          transition={{ duration: 1.8, delay: 0.25, ease: [0.22, 1, 0.36, 1] }}
        />
        <motion.circle
          cx="195"
          cy="50"
          r="5"
          fill="#FF4D0A"
          initial={{ opacity: 0 }}
          animate={inView ? { opacity: 1 } : { opacity: 0 }}
          transition={{ delay: 1.5, duration: 0.4 }}
        />
        <text x="205" y="40" fill="#FF4D0A" letterSpacing="1.5" style={MONO} className="text-[15px] sm:text-[11px]">
          WAKE SURGE
        </text>
        <text x="500" y="128" fill="#9DA1A8" letterSpacing="1.5" textAnchor="end" style={MONO} className="text-[15px] sm:text-[11px]">
          WIND DOWN
        </text>

        {HOURS.map(([x, l]) => (
          <text key={l} x={x} y="232" fill="#6E7178" textAnchor="middle" letterSpacing="1.5" style={MONO} className="text-[14px] sm:text-[10px]">
            {l}
          </text>
        ))}
      </svg>
      <div className="flex flex-wrap gap-x-8 gap-y-2 mt-3">
        <span className="inline-flex items-center gap-2 font-mono-brand text-[10px] tracking-[0.18em] uppercase text-[#9DA1A8]">
          <span className="w-4 h-[2px] bg-[#FF4D0A] inline-block" />
          Cortisol
        </span>
        <span className="inline-flex items-center gap-2 font-mono-brand text-[10px] tracking-[0.18em] uppercase text-[#9DA1A8]">
          <span className="w-4 h-[2px] bg-[#6E7178] inline-block" />
          Melatonin
        </span>
      </div>
      <p className="font-mono-brand text-[10px] tracking-[0.2em] uppercase text-[#6E7178] mt-4">
        Typical adult pattern on a regular sleep schedule.
      </p>
    </div>
  );
};
